import { render, staticRenderFns } from "./PatientTimeLine.vue?vue&type=template&id=5625023d&"
import script from "./PatientTimeLine.vue?vue&type=script&lang=js&"
export * from "./PatientTimeLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports